<template>
  <el-drawer title="已使用" :visible.sync="drawer" size="50%" :before-close="handleClose">
    <div class="m-tabs-content">
      <resource-list-page-content :pageData="usedData" :cols="cols" v-loading="loading"></resource-list-page-content>
    </div>
  </el-drawer>
</template>

<script>
import ResourceListPageContent from 'common/ResourceListPageContent'
import OrderStatus from './OrderStatus.vue';
import MerchantNum from './MerchantNum.vue';
import RefundStatus from './RefundStatus.vue';
import OrderAmount from './OrderAmount.vue';
export default {
  name: 'ShowUsedDrawer',
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    usedData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    ResourceListPageContent,
    OrderStatus,
    MerchantNum,
    RefundStatus,
    OrderAmount
  },
  data () {
    return {
      loading: false,
      cols: [
        { label: '订单号', prop: 'base_order.order_num' },
        { label: '商户订单号', prop: '', component: MerchantNum },
        { label: '支付人', prop: 'user.name' },
        { label: '手机号', prop: 'user.phone' },
        { label: '订单状态', prop: '', component: OrderStatus },
        { label: '退款状态', prop: '', component: RefundStatus },
        { label: '金额', prop: '', component: OrderAmount }
      ]
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    handleClose () {
      this.$emit('handleClose', false)
    }
  },
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner, .el-select {
  width 100%;
}
.el-form-item__content .el-input-group {
  vertical-align: middle;
}
.tr {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/coupon_codes/common/ShowUsedDrawer.vue